// extracted by mini-css-extract-plugin
module.exports = {"step_wrapper":"affiliate-step_step_wrapper__HinVn","step_icon_wrapper":"affiliate-step_step_icon_wrapper__VN9QN","step_text_wrapper":"affiliate-step_step_text_wrapper__0WzRW"};